import { render, staticRenderFns } from "./OTParcelReport.vue?vue&type=template&id=44a0f6ce&scoped=true&"
import script from "./OTParcelReport.vue?vue&type=script&lang=js&"
export * from "./OTParcelReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a0f6ce",
  null
  
)

export default component.exports